import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TEAM_PICKS } from './TeamData';
import './TeamSelection.css';

const NFL_TEAMS = Object.keys(TEAM_PICKS);

const TeamSelection = () => {
    const [selectedTeams, setSelectedTeams] = useState([]);
    const navigate = useNavigate();

    const toggleTeamSelection = (team) => {
        if (selectedTeams.includes(team)) {
            setSelectedTeams(selectedTeams.filter(t => t !== team));
        } else {
            setSelectedTeams([...selectedTeams, team]);
        }
    };

    const startDraft = () => {
        // Store selected teams and their picks in session storage
        sessionStorage.setItem('selectedTeams', JSON.stringify(selectedTeams));
        sessionStorage.setItem('teamPicks', JSON.stringify(TEAM_PICKS));
        navigate('/rankings');
    };

    return (
        <div className="team-selection-container">
            <h1>Select Your Team(s)</h1>
            <div className="teams-grid">
                {NFL_TEAMS.map((team) => (
                    <div
                        key={team}
                        className={`team-card ${selectedTeams.includes(team) ? 'selected' : ''}`}
                        onClick={() => toggleTeamSelection(team)}
                    >
                        <div className="team-name">{team}</div>
                        <div className="pick-numbers">
                            Picks: {TEAM_PICKS[team].join(', ')}
                        </div>
                    </div>
                ))}
            </div>
            <button 
                className="start-draft-button"
                onClick={startDraft}
                disabled={selectedTeams.length === 0}
            >
                START DRAFT
            </button>
        </div>
    );
};

export default TeamSelection;